import type { HiAttemptGetResponse } from '@/pages/homeInspection/hiAttempt.schema';
import type { HomeInspectionAttemptPsView } from '@/types/workOrderAttempt.types';

/** Adapt PS-enriched HI attempt into the standalone HI GET response shape. */
export const adaptPsHiAttemptToHiGetResponse = (
  hi: HomeInspectionAttemptPsView
): HiAttemptGetResponse => ({
  attemptId: hi.attemptId,
  workOrderId: hi.workOrderId,
  dateOfAttempt: hi.dateOfAttempt,
  timeOfAttempt: hi.timeOfAttempt,
  ownerAddressLine1: hi.ownerAddressLine1,
  ownerAddressLine2: hi.ownerAddressLine2,
  ownerCity: hi.ownerCity,
  ownerState: hi.ownerState,
  ownerZipCode: hi.ownerZipCode,
  ownerPhone: hi.ownerPhone,
  maritalStatus: hi.maritalStatus,
  spouseName: hi.spouseName,
  ownerOccupied: hi.ownerOccupied,
  vacant: hi.vacant,
  bothOwnersResideTogether: hi.bothOwnersResideTogether,
  coOwnerName: hi.coOwnerName,
  coOwnerAddressLine1: hi.coOwnerAddressLine1,
  coOwnerAddressLine2: hi.coOwnerAddressLine2,
  coOwnerCity: hi.coOwnerCity,
  coOwnerState: hi.coOwnerState,
  coOwnerZipCode: hi.coOwnerZipCode,
  defendantInArmedForces: hi.defendantInArmedForces,
  tenantOccupied: hi.tenantOccupied,
  relative: hi.relative,
  lease: hi.lease,
  rentAmount: hi.rentAmount == null ? null : Number(hi.rentAmount),
  houseExterior: hi.houseExterior,
  houseExteriorOther: hi.houseExteriorOther,
  houseType: hi.houseType,
  numberOfUnits: hi.numberOfUnits,
  garage: hi.garage,
  sale: hi.sale,
  saleBy: hi.saleBy,
  salePhone: hi.salePhone,
  saleDate: hi.saleDate,
  comments: hi.comments,
  inspectorId: hi.inspectorId,
  inspector: null,
  createdById: hi.createdById,
  createdBy: { userId: hi.createdById, firstName: '', lastName: '' },
  updatedById: hi.updatedById,
  updatedBy: null,
  editableUntil: null,
  createdAt: hi.createdAt,
  updatedAt: hi.updatedAt,
  tenants: hi.tenants,
  media: hi.media.map((m) => ({
    attemptMediaId: m.attemptMediaId,
    attemptId: m.attemptId,
    mediaId: m.mediaId,
    createdAt: m.createdAt,
    media: m.media ?? {
      mediaId: m.mediaId,
      type: '',
      mimeType: '',
      path: '',
      bucketName: '',
      baseUrl: '',
      createdAt: m.createdAt,
    },
  })),
});
